import PropTypes from "prop-types";
import { useRef } from "react";
import { StyledToggleButton } from "./BaseToggleButton.styles";

const ControlledToggleButton = ({ checked, onChange, ...props }) => {
    const elRef = useRef();
    const internalOnChange = (event) => {
        if (typeof onChange === "function") {
            onChange(event);
        }
    };

    return (
        <StyledToggleButton
            {...props}
            checked={checked}
            onChange={internalOnChange}
            type="checkbox"
            ref={elRef}
        />
    );
};

ControlledToggleButton.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
};

export default ControlledToggleButton;
